import * as actionTypes from '../types/stockConfigure';

const initialState = {
  listStocks: [],
  loading: false,
  error: false,
  add: {
    loading: false,
    okAdd: false,
    errorAdd: false
  },
  delete: {
    loading: false,
    okDelete: false,
    errorDelete: false
  }
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_STOCK_CONFIGURE_LIST: {
      return {
        ...state,
        loading: true,
        error: false
      };
    }
    case actionTypes.GET_STOCK_CONFIGURE_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        listStocks: payload
      };
    }
    case actionTypes.GET_STOCK_CONFIGURE_LIST_FAIL: {
      return {
        ...state,
        loading: false,
        error: payload,
        listStocks: []
      };
    }
    case actionTypes.ADD_NEW_STOCK_LEVEL: {
      return {
        ...state,
        add: {
          ...state.add,
          loading: true,
          okAdd: false,
          errorAdd: false
        }
      };
    }
    case actionTypes.ADD_NEW_STOCK_LEVEL_SUCCESS: {
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          okAdd: true,
          errorAdd: false
        }
      };
    }
    case actionTypes.ADD_NEW_STOCK_LEVEL_FAIL: {
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          okAdd: false,
          errorAdd: payload
        }
      };
    }
    case actionTypes.DELETE_STOCK_LEVEL: {
      return {
        ...state,
        delete: {
          ...state.delete,
          loading: true,
          errorDelete: false,
          okDelete: false
        }
      };
    }
    case actionTypes.DELETE_STOCK_LEVEL_SUCCESS: {
      return {
        ...state,
        delete: {
          ...state.delete,
          loading: false,
          okDelete: true,
          errorDelete: false
        }
      };
    }
    case actionTypes.DELETE_STOCK_LEVEL_FAIL: {
      return {
        ...state,
        delete: {
          ...state.delete,
          loading: false,
          okDelete: false,
          errorDelete: payload
        }
      };
    }
    default:
      return state;
  }
};

export default reducer;
